import { render, staticRenderFns } from "./AddCrew.vue?vue&type=template&id=4b5222b9&"
import script from "./AddCrew.vue?vue&type=script&lang=js&"
export * from "./AddCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports